import dayjs from 'dayjs'

import { get } from '@services/clients/fetch'

import { ENTRIES_FETCH_LIMIT, LEGACY_CATEGORY_MAPPINGS } from '@utils/constants'
import logger from '@utils/logger'

export const getEntries = pathFromCacheKey => get(pathFromCacheKey)

export const getEntriesCacheKey = (index, previousData, { filters, sortBy }) => {
  if (previousData && !previousData?.entries) return null

  const params = new URLSearchParams()

  if (filters.searchText.length) params.append('query', filters.searchText.join(' '))
  if (filters.countries.length) params.append('fields.country[in]', filters.countries.join(','))
  if (filters.categories.length) params.append('fields.category[in]', _getCurrentAndLegacyCategories(filters.categories))
  if (filters.fcpIds.length) params.append('fields.fcpId[in]', filters.fcpIds.join(','))

  if (filters.startDate) params.append('sys.createdAt[gte]', dayjs(filters.startDate).toISOString())
  if (filters.endDate) params.append('sys.createdAt[lte]', dayjs(filters.endDate).toISOString())

  if (sortBy) params.append('order', sortBy)

  params.append('fields.media[exists]', true)
  params.append('limit', ENTRIES_FETCH_LIMIT)
  params.append('skip', ENTRIES_FETCH_LIMIT * index)

  logger.info('Media Search', { filters })

  return '/entries?' + params.toString()
}

const _getCurrentAndLegacyCategories = selectedCategories =>
  [
    ...selectedCategories,
    ...Object.entries(LEGACY_CATEGORY_MAPPINGS)
      .filter(([, currentCategory]) => selectedCategories.includes(currentCategory))
      .map(([legacyCategory]) => legacyCategory)
  ].join(',')
